import { ConceptPageTabType } from '../conceptPage/types';
import { createAction, createReducer } from '@reduxjs/toolkit';
const baseState = {
    activeTab: ConceptPageTabType.ARTISANS,
};
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_ACTIVE_TAB"] = "SET_ACTIVE_TAB";
})(ActionTypes || (ActionTypes = {}));
const SetTabAction = createAction(ActionTypes.SET_ACTIVE_TAB);
const conceptPageReducer = createReducer(baseState, (builder) => {
    builder.addCase(SetTabAction, (state, action) => {
        state.activeTab = action.payload;
    });
});
export default conceptPageReducer;
